import React, {Component} from 'react'
import PropTypes from 'prop-types'
import CheckLineItem from "../../CheckPage/components/CheckLineItem"


class ItemDetail extends Component {
    _getItem = () => {
        const {order, index} = this.props

        const {products} = order
        if (!products || !products.length) return false

        const product = products.find((_product, _index) => {
            const vPos = parseInt(_product.pos || _index, 10)

            return vPos === index
        })

        return product || false
    }

    _handleSyncDesign = () => {
    }

    render() {
        const product = this._getItem()
        if (!product) {
            return null
        }


        const {order, index} = this.props
        const {barcodeNumber} = order

        return (
            <div className="ItemDetail">
                <CheckLineItem product={product}
                               onSyncDesign={this._handleSyncDesign}
                               id={`${barcodeNumber}_${index}`} hiddenButtonQC={true}/>
            </div>
        )
    }
}

ItemDetail.proTypes = {
    order: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
}

export default ItemDetail
